const COOKIE_NAME = 'cookieConsent_status';
const COOKIE_MAX_AGE_DAYS = 365;
const ACCEPT_VALUE = 'features,marketing,statistics';
const REJECT_VALUE = 'features';

function hasConsentCookie(): boolean {
  return document.cookie.split('; ').some((entry) => {
    const eq = entry.indexOf('=');
    if (eq <= 0) return false;
    return entry.slice(0, eq) === COOKIE_NAME && entry.slice(eq + 1).length > 0;
  });
}

function persistChoice(action: 'accept' | 'reject'): void {
  const value = action === 'accept' ? encodeURIComponent(ACCEPT_VALUE) : REJECT_VALUE;
  const maxAge = COOKIE_MAX_AGE_DAYS * 24 * 60 * 60;
  const secure = window.location.protocol === 'https:' ? '; secure' : '';
  document.cookie = `${COOKIE_NAME}=${value}; max-age=${maxAge}; path=/; samesite=lax${secure}`;
}

function dismiss(banner: HTMLElement): void {
  banner.remove();
}

export function initCookieConsent(): void {
  const banner = document.querySelector<HTMLElement>('[data-fc-cookie]');
  if (!banner) return;
  if (banner.classList.contains('fc-edit-mode')) return;

  if (hasConsentCookie()) {
    banner.remove();
    return;
  }

  banner.hidden = false;

  if (banner.classList.contains('fc-edit-mode')) return;

  if (hasConsentCookie()) {
    banner.remove();
    return;
  }

  banner.hidden = false;

  banner.addEventListener('click', (evt) => {
    const target = (evt.target as HTMLElement | null)?.closest<HTMLElement>(
      '[data-fc-cookie-action]',
    );
    if (!target) return;
    const action = target.dataset.fcCookieAction;
    if (action !== 'accept' && action !== 'reject') return;
    persistChoice(action);
    dismiss(banner);
  });
}
